module.exports = global["$"] = require("-!/data/srv/cabinet.amursu.ru/shared/node_modules/babel-loader/lib/index.js??ref--7-0!./jquery.js");